import React from 'react'
import { Sponsor } from '../../Utils'
import { SponsorItemCon } from './styles'
import { Img } from '../Image/Img'
import { Lk } from '../Links/Lk'

type SponsorData = {
  sponsor: Sponsor
}

export const SponsorItem: React.FC<React.PropsWithChildren<SponsorData>> = ({
  sponsor,
}) => {
  return (
    <SponsorItemCon sponsorType={sponsor.sponsorType}>
      <Lk link={sponsor.link} alt={`${sponsor.name} sponsor`}>
        <Img
          className="sponsorImg"
          src={sponsor.image}
          alt={`Sponsor icon for ${sponsor.name}`}
        />
      </Lk>
    </SponsorItemCon>
  )
}
